export const screenerCopyDe = {
    start: "Starten",
    starting: "Wird gestartet...",
    checking: "Ihre Antworten werden geprüft...",
    notFoundTitle: "Dieser Link funktioniert nicht",
    notFoundBody:
        "Der Fragebogen ist möglicherweise geschlossen. Wenden Sie sich an das Team, das Ihnen diesen Link gegeben hat.",
    eligibleTitle: "Sie können teilnehmen",
    eligibleBody: "Erstellen Sie Ihr Konto, um zu beginnen.",
    ineligibleTitle: "Das passt leider nicht für Sie",
    ineligibleBody:
        "Vielen Dank für Ihre Antworten. Nach Ihren Antworten erfüllen Sie die Kriterien nicht. Bei Fragen wenden Sie sich an das Team, das Ihnen diesen Link gegeben hat.",
    continueToSignUp: "Weiter zur Registrierung",
    scanOnPhone: "Oder scannen Sie diesen Code mit der Kamera Ihres Telefons, um sich dort zu registrieren.",
    startAgain: "Neu beginnen",
};
